import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { TopHeader } from '@carboledger/ui';
import { ROUTES } from '@/app/routes';
import { APP_NAME } from './layout.constants';
import { UserMenu } from './UserMenu';
import logoUrl from '@/assets/carboledger-logo.png';
import styles from './AppTopHeader.module.scss';

/**
 * Props:
 *   menu     leading control, e.g. the module switcher
 *   actions  trailing controls, e.g. the site switcher
 */
export const AppTopHeader = ({ menu = null, actions = null }) => {
  const navigate = useNavigate();

  const handleHome = useCallback(() => navigate(ROUTES.home), [navigate]);
  const handleNotifications = useCallback(() => {
    // TODO: open the notifications panel once that feature exists.
  }, []);

  const logo = useMemo(() => <img src={logoUrl} alt="Carboledger" className={styles.logo} />, []);
  const avatar = useMemo(() => <UserMenu />, []);

  return (
    <TopHeader
      logo={logo}
      productName={APP_NAME}
      onHome={handleHome}
      menu={menu}
      actions={actions}
      onNotificationsClick={handleNotifications}
      notificationCount={0}
      avatar={avatar}
    />
  );
};
